import { useMemo } from "react"

import { ApiService } from "@/domains/api/api-service"
import { safelyFetch } from "@/domains/api/safely-fetch"
import { baseBetaBranches, baseProdBranches } from "@/features/constants"

import { useChainConfig } from "./use-chain-config"

export const useApiService = () => {
  const chainConfig = useChainConfig()

  return useMemo(() => {
    const baseUrl = getBranchApiBaseUrl(chainConfig.branch)
    return new ApiService({
      baseUrl,
      safelyFetch,
    })
  }, [chainConfig.branch])
}

/**
 * Extend this to add your branch
 */
const getBranchApiBaseUrl = (branch: string): string => {
  if (baseProdBranches.includes(branch)) {
    return import.meta.env.VITE_PROD_SCALE_PROXY_API || ""
  }

  if (baseBetaBranches.includes(branch)) {
    return import.meta.env.VITE_BETA_SCALE_PROXY_API || ""
  }

  if (import.meta.env.VITE_SCALE_PROXY_API) {
    return import.meta.env.VITE_SCALE_PROXY_API || ""
  }

  throw new Error(`Chain "${branch}" not supported`)
}
